var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import WalletBar from '../../parts/WalletBar.vue';
import Calculator from '../../parts/Calculator.vue';
import { XEM } from "nem-library";
import { createWithNewAmount } from "../../../lib/mosaicUtils";
import { MUTATION_TYPES } from "../../../lib/mutationTypes";
import ToolBar from "../../parts/ToolBar.vue";
import { WalletsHelper } from "../../../lib/storage";
import BalanceModule from "../../mixins/BalanceModule";
export default Vue.extend({
    mixins: [BalanceModule],
    components: {
        ToolBar,
        Calculator, WalletBar
    },
    name: "SendAmount",
    data() {
        return {
            type: "amount",
            currency: Object.keys(this.$store.state.sendMosaics)[0],
            sendXem: Object.keys(this.$store.state.sendMosaics).indexOf('nem:xem') >= 0,
            attachments: Object.keys(this.$store.state.sendMosaics).filter(value => value != 'nem:xem'),
        };
    },
    computed: {
        calculatorValue() {
            return this.$store.state.calculatorValue;
        }
    },
    methods: {
        updateSendAmount() {
            const notSendXem = this.attachments.length > 0 && !this.sendXem;
            if (notSendXem) {
                this.$store.commit(MUTATION_TYPES.REMOVE_SEND_MOSAIC, 'nem:xem');
            }
            else if (Object.keys(this.$store.state.sendMosaics).indexOf('nem:xem') < 0) {
                this.$store.commit(MUTATION_TYPES.ADD_SEND_MOSAIC, new XEM(0));
            }
            for (let attachment of this.attachments) {
                if (!(attachment in this.$store.state.sendMosaics)) {
                    const mosaicInfo = this.getOwnedMosaicInfo(attachment);
                    if (mosaicInfo != null) {
                        const newMosaic = createWithNewAmount(mosaicInfo, 0);
                        this.$store.commit(MUTATION_TYPES.ADD_SEND_MOSAIC, newMosaic);
                    }
                }
            }
            for (let attachment in this.$store.state.sendMosaics) {
                if (attachment === 'nem:xem') {
                    continue;
                }
                if (this.attachments.indexOf(attachment) < 0) {
                    this.$store.commit(MUTATION_TYPES.REMOVE_SEND_MOSAIC, attachment);
                }
            }
        },
        switchAttachment(fullName) {
            const index = this.attachments.indexOf(fullName);
            if (index >= 0) {
                this.attachments.splice(index, 1);
            }
            else {
                this.attachments.push(fullName);
            }
        },
        getOwnedMosaicInfo(fullName) {
            for (let mosaic of this.ownedMosaics) {
                if (mosaic.mosaicId.description() === fullName) {
                    return mosaic;
                }
            }
            return null;
        }
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            const activeWallet = yield WalletsHelper.getActive();
            if (!activeWallet) {
                return;
            }
            yield this.fetchBalance(true);
            if (this.currency in this.$store.state.sendMosaics) {
                const mosaicInfo = this.$store.state.sendMosaics[this.$data.currency];
                this.$store.commit(MUTATION_TYPES.SET_CALCULATOR_FORMULA, mosaicInfo.amount.toString());
            }
        });
    },
    watch: {
        attachments() {
            this.updateSendAmount();
        },
        sendXem() {
            this.updateSendAmount();
        },
        calculatorValue() {
            const mosaicInfo = this.getOwnedMosaicInfo(this.$data.currency);
            if (mosaicInfo != null) {
                const newMosaic = createWithNewAmount(mosaicInfo, this.$store.state.calculatorValue);
                this.$store.commit(MUTATION_TYPES.ADD_SEND_MOSAIC, newMosaic);
            }
        },
        type() {
            if (!(this.$data.currency in this.$store.state.sendMosaics)) {
                this.$data.currency = Object.keys(this.$store.state.sendMosaics)[0];
            }
        },
        currency() {
            // delay for waiting the tab scrolled
            window.setTimeout(() => {
                const mosaicInfo = this.$store.state.sendMosaics[this.$data.currency];
                if (mosaicInfo) {
                    this.$store.commit(MUTATION_TYPES.SET_CALCULATOR_FORMULA, mosaicInfo.amount.toString());
                }
            }, 300);
        },
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/send/SendAmount.vue
// module id = 650
// module chunks = 1